import axios from '@/request';
import qs from 'qs';

export default {
  async list(params: any) {
    return axios.get('oplatform/wxamplink/list', { params });
  },
  async add(params: any) {
    return axios.post('oplatform/wxamplink/add', qs.stringify(params));
  },
  async delete(params: any) {
    return axios.post('oplatform/wxamplink/delete', qs.stringify(params));
  }
};
